<app-tabla
  [totalCount]="totalCount"
  [datos]="notas"
  [columnas]="columnas"
  [name]="name"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [showHijos]="false"
  [crear]="botonCrear"
  [emptyState]="{
    title:
      tipo === 'Contacto'
        ? 'Todavía no hay contactos'
        : 'Todavía no hay notas',
  }"
></app-tabla>
